/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台
 */
'use strict';
angular.module("backstageModule", [
	'backstageRouterModule',
	'backstageLeftModule',
	'userManagementModule', //后台-用户管理
	'organizationManagementModule', //后台-组织管理
	'ugcManageModule', //后台-ugc稿件管理
	'pgcManageModule', //后台-pgc稿件管理
	'noticeManagementModule', //后台-公告管理
	"loginMangementModule"
]).
controller('backstageCtrl', ['$scope', 'httpService', '$location', '$q', '$element', '$timeout', '$state', function($scope, httpService, $location, $q, $element, $timeout, $state) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			inputData: ''
		};
		$scope.data = {};
	}

	function initData() {
		/**
		 * 这里是获取是否配置了二级域名 如果没有配置的话 我们要进引导页 
		 */
		$timeout(function() {
			$("html").css('backgroundColor','#F5F7FA')
		})
	}
}]);